function _0x13b5() {
  const _0x444a9b = [
    'meta[name=',
    'iewMode',
    'getAttribu',
    'data',
    'ack',
    'dal--callb',
    'MnFRc',
    '.theme__mo',
    '266672DCnQxF',
    'JxcmS',
    '3569656Sitphh',
    'content',
    'innerHTML',
    'productCar',
    'shopifypre',
    'hBZML',
    'XeADq',
    'tForm',
    'PRxLy',
    'replace',
    'view',
    'error',
    'REZcT',
    'mlQUj',
    'QPXmm',
    'khVqm',
    'www.',
    '3gZfkyV',
    'gLnMj',
    'Rfrfi',
    'ned',
    '2|1|0|3|4|',
    'WbpFZ',
    'split',
    'shopping',
    'chwYc',
    '\x22shop-url\x22',
    'iuYZx',
    'visualPrev',
    'body',
    'toLowerCas',
    'shop',
    '48KYfHAk',
    '2233578zFqRBl',
    'includes',
    'djcap',
    'hPgBK',
    'LBSwT',
    '606920Saptfc',
    '7cPBniB',
    '1761192jQpWwB',
    '5285574ktcGRn',
    'json',
    'i/v1/',
    '229190yibTqO',
    'undefined',
    'tor',
    'allSliders',
    'HsgTx',
    'isModalOpe',
    'eme.com/ap',
    'querySelec',
    'https://ww',
    'state',
    'cart',
    'inspectMod',
    'user',
    'active',
    'shops/chec',
    'domain',
    'w.story-th',
  ];
  _0x13b5 = function () {
    return _0x444a9b;
  };
  return _0x13b5();
}
const _0x1f585 = _0x2b1e;
(function (_0x217a26, _0x5be702) {
  const _0x3f595f = _0x2b1e,
    _0xe263b8 = _0x217a26();
  while (!![]) {
    try {
      const _0x1be4bc =
        -parseInt(_0x3f595f(0x1a0)) / (0x5e5 * -0x3 + -0x1071 + 0x2221) +
        -parseInt(_0x3f595f(0x17c)) / (-0x2475 + 0x1 * 0x152b + -0x2 * -0x7a6) +
        (parseInt(_0x3f595f(0x1b3)) / (0x1504 + 0x13b1 + -0x28b2)) *
          (parseInt(_0x3f595f(0x1a2)) /
            (0xd * 0x295 + -0x18 * 0x5b + -0x1905)) +
        (parseInt(_0x3f595f(0x187)) / (0x11d5 * -0x1 + -0x18fd + 0x2ad7)) *
          (parseInt(_0x3f595f(0x17b)) /
            (0x1985 + 0xe9 * 0x23 + -0x3 * 0x131e)) +
        (-parseInt(_0x3f595f(0x182)) /
          (-0x5ef * -0x1 + -0x1 * 0x183b + 0x1253)) *
          (-parseInt(_0x3f595f(0x183)) /
            (-0x53d * -0x3 + 0x268a + -0x15 * 0x295)) +
        parseInt(_0x3f595f(0x184)) / (0x95d + 0x14a9 + -0x1dfd) +
        -parseInt(_0x3f595f(0x181)) / (-0x18fb + -0x8 * 0x3ec + 0x1 * 0x3865);
      if (_0x1be4bc === _0x5be702) break;
      else _0xe263b8['push'](_0xe263b8['shift']());
    } catch (_0x44ba43) {
      _0xe263b8['push'](_0xe263b8['shift']());
    }
  }
})(_0x13b5, -0xb * 0x6ceb + -0x39f07 + -0x11cc6 * -0x10);
let oldDomain = '';
domainName[_0x1f585(0x179) + 'e']() !== ''
  ? (oldDomain = domainName[_0x1f585(0x179) + 'e']())
  : (oldDomain = document[_0x1f585(0x196)]
      [_0x1f585(0x179) + 'e']()
      [_0x1f585(0x17d)](_0x1f585(0x1b2))
      ? document[_0x1f585(0x196)]
          [_0x1f585(0x179) + 'e']()
          [_0x1f585(0x1ab)](_0x1f585(0x1b2), '')
      : document[_0x1f585(0x196)][_0x1f585(0x179) + 'e']());
const domain = document[_0x1f585(0x18e) + _0x1f585(0x189)](
    _0x1f585(0x198) + _0x1f585(0x175) + ']'
  )
    ? document[_0x1f585(0x18e) + _0x1f585(0x189)](
        _0x1f585(0x198) + _0x1f585(0x175) + ']'
      )[_0x1f585(0x19a) + 'te'](_0x1f585(0x1a3))
    : oldDomain,
  url = _0x1f585(0x18f) + _0x1f585(0x197) + _0x1f585(0x18d) + _0x1f585(0x186);
function _0x2b1e(_0x9b1d41, _0x3a4b17) {
  const _0x472a46 = _0x13b5();
  return (
    (_0x2b1e = function (_0x51a23b, _0x8a9513) {
      _0x51a23b = _0x51a23b - (-0x13ba + -0x1386 + 0x364 * 0xc);
      let _0x3e5847 = _0x472a46[_0x51a23b];
      return _0x3e5847;
    }),
    _0x2b1e(_0x9b1d41, _0x3a4b17)
  );
}
cartIcon = _0x1f585(0x191);
typeof window[_0x1f585(0x18c) + _0x1f585(0x1b6)] === _0x1f585(0x188) &&
  (window[_0x1f585(0x18c) + _0x1f585(0x1b6)] = ![]);
const openModal = () => {
  const _0x1e9e56 = _0x1f585,
    _0x3cec6b = {
      MnFRc: _0x1e9e56(0x19f) + _0x1e9e56(0x19d) + _0x1e9e56(0x19c),
    };
  if (window[_0x1e9e56(0x18c) + _0x1e9e56(0x1b6)]) return;
  const _0x99442c = document[_0x1e9e56(0x18e) + _0x1e9e56(0x189)](
    _0x3cec6b[_0x1e9e56(0x19e)]
  );
  _0x99442c
    ? (document[_0x1e9e56(0x178)][_0x1e9e56(0x1a4)] =
        _0x99442c[_0x1e9e56(0x1a4)])
    : (document[_0x1e9e56(0x178)][_0x1e9e56(0x1a4)] = ''),
    (window[_0x1e9e56(0x18c) + _0x1e9e56(0x1b6)] = !![]);
};
(async () => {
  const _0x1f17e7 = _0x1f585,
    _0x254496 = {
      khVqm: function (_0x256aac) {
        return _0x256aac();
      },
      JxcmS: function (_0x4c5cba) {
        return _0x4c5cba();
      },
      gLnMj: function (_0xf540bc, _0x283492) {
        return _0xf540bc !== _0x283492;
      },
      REZcT: function (_0x47f861, _0x473b8a) {
        return _0x47f861 !== _0x473b8a;
      },
      hBZML: _0x1f17e7(0x191),
      iuYZx: function (_0x2213a2, _0x32869e) {
        return _0x2213a2 !== _0x32869e;
      },
      PRxLy: _0x1f17e7(0x170) + '5',
      HsgTx: _0x1f17e7(0x1a5) + _0x1f17e7(0x1a9),
      WbpFZ: _0x1f17e7(0x18a),
      djcap: function (_0x2475d2, _0x1c54c2) {
        return _0x2475d2 + _0x1c54c2;
      },
      XeADq: _0x1f17e7(0x173),
      chwYc: function (_0x1c5780, _0x227bf) {
        return _0x1c5780 !== _0x227bf;
      },
      mlQUj: _0x1f17e7(0x188),
      hPgBK: _0x1f17e7(0x1a6) + _0x1f17e7(0x1ac),
      QPXmm: function (_0x442b04, _0x46320b) {
        return _0x442b04(_0x46320b);
      },
      Rfrfi: function (_0x356496, _0x104928, _0x5df2c2) {
        return _0x356496(_0x104928, _0x5df2c2);
      },
      LBSwT: _0x1f17e7(0x194),
    };
  try {
    if (
      _0x254496[_0x1f17e7(0x1b4)](t, undefined) &&
      _0x254496[_0x1f17e7(0x1b4)](p, undefined) &&
      _0x254496[_0x1f17e7(0x1ae)](y, undefined) &&
      _0x254496[_0x1f17e7(0x1b4)](cartIcon, _0x254496[_0x1f17e7(0x1a7)]) &&
      _0x254496[_0x1f17e7(0x1ae)](productCartForm, undefined) &&
      _0x254496[_0x1f17e7(0x176)](allSliders, undefined)
    )
      _0x254496[_0x1f17e7(0x1b1)](openModal);
    else {
      const _0x10c25c = _0x254496[_0x1f17e7(0x1aa)][_0x1f17e7(0x172)]('|');
      let _0x26c804 = -0x254c + 0x465 * -0x7 + 0x440f;
      while (!![]) {
        switch (_0x10c25c[_0x26c804++]) {
          case '0':
            productCartForm = _0x254496[_0x1f17e7(0x18b)];
            continue;
          case '1':
            t = 0x269b + -0x116 * 0x9 + -0x1cd2;
            continue;
          case '2':
            allSliders = _0x254496[_0x1f17e7(0x171)];
            continue;
          case '3':
            p = 'ov';
            continue;
          case '4':
            y = _0x254496[_0x1f17e7(0x17e)](0xa76 + 0x2046 + 0x2aba * -0x1, t);
            continue;
          case '5':
            cartIcon = _0x254496[_0x1f17e7(0x1a8)];
            continue;
        }
        break;
      }
    }
    if (
      _0x254496[_0x1f17e7(0x174)](
        typeof Shopify,
        _0x254496[_0x1f17e7(0x1af)]
      ) &&
      (Shopify[_0x1f17e7(0x192) + 'e'] ||
        Shopify[_0x1f17e7(0x177) + _0x1f17e7(0x199)])
    ) {
    } else {
      if (domain[_0x1f17e7(0x17d)](_0x254496[_0x1f17e7(0x17f)])) {
      } else {
      }
    }
  } catch (_0x1afa26) {
    console[_0x1f17e7(0x1ad)](_0x1afa26);
  }
})();